import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import UserBadge from "./UserBadge";
import "./style-new.css";

import {
  FaSignInAlt,
  FaUserPlus,
  FaCalendarAlt,
  FaUsers,
  FaComments,
  FaBell,
} from "react-icons/fa";


const Home = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const isLoggedIn = !!token;
  const [unreadCount, setUnreadCount] = useState(0);
  const [chatUnread, setChatUnread] = useState(0);
  let name = "";

  try {
    if (token) {
      const decoded = jwtDecode(token);
      name = decoded.name || "";
    }
  } catch (err) {
    console.error("Invalid token", err);
  }

useEffect(() => {
  if (!token) return;

  // Fetch unread notifications
  fetch("/api/notifications/unread-count", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        setUnreadCount(data.unreadCount || 0);
      }
    })
    .catch((err) =>
      console.error("Failed to fetch unread notifications count", err)
    );

  // Fetch unread chat messages (group + direct)
  fetch("/api/chat/unread-count", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      setChatUnread((data.groupUnread || 0) + (data.directUnread || 0));
    })
    .catch((err) =>
      console.error("Failed to fetch unread chat count", err)
    );
}, [token]);


  return (
    <div className="page-container">
      <UserBadge />

      <div className="center-content">
        <h1 className="welcome-heading">
          Welcome to Teamo{name ? `, ${name}` : ""}
        </h1>
        <p className="slogan-text">Get Organized, Get Playing!</p>

        {!isLoggedIn ? (
          <div className="button-group">
            <button className="btn btn-primary" onClick={() => navigate("/login")}>
              <FaSignInAlt />
              Login
            </button>
            <button className="btn btn-primary" onClick={() => navigate("/signup")}>
              <FaUserPlus />
              Sign Up
            </button>
          </div>
        ) : (
          <div className="button-group">
            <button className="btn btn-primary" onClick={() => navigate("/games")}>
              <FaCalendarAlt />
              Games
            </button>
            <button className="btn btn-primary" onClick={() => navigate("/groups")}>
              <FaUsers />
              Groups
            </button>
             <button
  className="btn btn-primary"
  onClick={() => navigate("/chat")}
  style={{ position: "relative" }}
>
  <FaComments />
  Chat
  {chatUnread > 0 && (
    <span className="badge">{chatUnread}</span>
  )}
</button>

            <button
              className="btn btn-primary"
              onClick={() => navigate("/notifications")}
              style={{ position: "relative" }}
            >
              <FaBell />
              Notifications
              {unreadCount > 0 && (
                <span className="badge">{unreadCount}</span>
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;
